import { SortDirection } from "@episerver/ui-framework";
import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../store";
import { Contact } from "../../ContactManager/model/contact";
import { searchAvailableUserAccountAssignments, fetchUserAccountAssignments } from "../../ContactManager/reducers/asyncThunks";
import { PaginationModel, SortModel } from "../model/contact";

export const initialAddAssignmentsToUserState = {
    userId: "",
    title: "Add accounts to user",
    open: false,
    keyword: "",
    contacts: [] as Contact[],
    selectedContacts: [] as Contact[],
    sort: {
        sortedColumn: "FullName",
        sortDirection: SortDirection.Ascending,
    } as SortModel,
    contactListPagination: {
        startRow: 0,
        rowsPerPage: 10,
        rowsPerPageOptions: [10, 15, 20],
        totalRowCount: 0,
    } as PaginationModel,
};

export const addAssignmentsToUserSlice = createSlice({
    name: "addAssignmentsToUser",
    initialState: initialAddAssignmentsToUserState,
    reducers: {
        onChangeDialog: (state, action): void => {
            state.open = action.payload.open;
            state.contactListPagination.startRow = initialAddAssignmentsToUserState.contactListPagination.startRow;
        },
        selectContact: (state, action) => {
            state.selectedContacts.push(action.payload);
        },
        deselectContact: (state, action) => {
            state.selectedContacts = state.selectedContacts.filter(
                (contact: Contact) => contact.primaryKeyId !== action.payload.primaryKeyId
            );
        },
        selectAllContacts: (state) => {
            state.selectedContacts = state.contacts;
        },
        deselectAllContacts: (state) => {
            state.selectedContacts = [];
        },
        sort: (state, action): void => {
            const { column, direction } = action.payload;
            state.sort = { sortDirection: direction, sortedColumn: column };
        },

        changeKeyword: (state, action): void => {
            state.keyword = action.payload;
        },
    },
    extraReducers: {
        [`${searchAvailableUserAccountAssignments.fulfilled}`]: (state, action): void => {
            state.contacts = action.payload.contacts;
            state.contactListPagination.startRow = action.payload.pagingInfo.startRow;
            state.contactListPagination.rowsPerPage = action.payload.pagingInfo.rowsPerPage;
            state.contactListPagination.totalRowCount = action.payload.pagingInfo.totalRowCount; 
        },
        [`${fetchUserAccountAssignments.fulfilled}`]: (state, action): void => {
            state.selectedContacts = action.payload;
        
        }
    },
});

// Actions
export const {
    onChangeDialog,
    selectContact,
    deselectContact,
    selectAllContacts,
    deselectAllContacts,
    sort,
    changeKeyword,
} = addAssignmentsToUserSlice.actions;

// Selectors
export const contactsSelector = (state: RootState) => state.addAssignmentsToUser.contacts;

export const sortSelector = (state: RootState) => state.addAssignmentsToUser.sort;

export const contactListPaginationSelector = (state: RootState): PaginationModel =>
    state.addAssignmentsToUser.contactListPagination;

export const selectedContactsSelector = (state: RootState): Contact[] =>
    state.addAssignmentsToUser.selectedContacts;

export const isOpenDialogSelector = (state: RootState): boolean => state.addAssignmentsToUser.open;

export const addContactsTitleSelector = (state: RootState): string => state.addAssignmentsToUser.title;

export const userIdSelector = (state: RootState): string => state.addAssignmentsToUser.userId;

export const keywordSelector = (state: RootState): string => state.addAssignmentsToUser.keyword;
